import { actionSet } from './utils'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner } from './spinner'

import {
  LIST_DATASHEET_FORMAT_SUCCESS,
  LIST_DATASHEET_FORMAT_ERROR,
  LIST_DATASHEET_FORMAT_REQUEST
} from 'constants/actionTypes'

export const listDatasheetFormat =
(token, signalController) => (dispatch) => {
  dispatch(actionSet(LIST_DATASHEET_FORMAT_REQUEST))

  const onMessage = (response) =>{
    dispatch(actionSet(LIST_DATASHEET_FORMAT_SUCCESS, [response.data]))
  }

  const onClose = () => {
    console.log("Conexão listDatasheetFormat encerrada");
  }

  const onError = (error) => {
    dispatch(actionSet(LIST_DATASHEET_FORMAT_ERROR, error))
  }

  const abort = () => {
    signalController.abort()
    onClose()
  }

  dispatch(showSpinner("", true, abort))

  return new Api(token, dispatch)
    .eventSourceStream(API_URL.LIST_DATASHEET_FORMAT, null, null, signalController, onMessage, onClose, onError)
    .catch((error) => onError(error))
}